export default class AdobeDigitalData {
    selectors = {
        acdlLinks: 'a[data-acdl-event], button[data-acdl-event], input[data-acdl-event]',
    };

    elements = {
        pageObj: null,
        updatedACDL: null,
        acdlLinks: null,
    };

    variables = {
        isFieldsValid: true,
    };

    eTOCEvents = {
        successCTA: () => {
            this.pushToACDL({
                event: 'alert-signup-success',
                eTOC: {name: 'journal alert cta'},
            });
        },

        submitForm: () => {
            this.pushToACDL({
                event: 'alert-signup-submit',
                eTOC: {name: 'alert simple sign-up form'},
            });
        },

        requestVerificationShown: () => {
            this.pushToACDL({
                event: 'request-verification-shown',
                eTOC: {name: 'alert simple sign-up form'},
            });
        },

        requestVerification: () => {
            this.pushToACDL({
                event: 'request-verification',
                eTOC: {name: 'alert simple sign-up form'},
            });
        },

        contactSupport: () => {
            this.pushToACDL({
                event: 'contact-customer-service',
                eTOC: {name: 'alert simple sign-up form'},
            });
        },
    };

    registrationEvents = {
        error: message => {
            this.pushToACDL({
                event: 'registration-form-error',
                registration: {
                    step: 'registration form error',
                    'error-message': message,
                },
            });
        },

        submitted: () => {
            this.pushToACDL({
                event: 'registration-form-submitted',
                registration: {step: 'registration form submitted'},
            });
        },

        completed: () => {
            this.pushToACDL({
                event: 'registration',
                registration: {step: 'registration completed'},
            });
        },
    };

    loginEvents = {
        error: message => {
            this.pushToACDL({
                event: 'login-error',
                login: {
                    step: 'login error',
                    'error-message': message,
                },
            });
        },

        success: () => {
            this.pushToACDL({
                event: 'login-success',
                login: {step: 'login success'},
            });
        },
    };

    eCommerce = {
        AddressVerification: () => {
            this.pushToACDL({
                event: 'cart-address-verify',
            });
        },
        PaymentErrors: message => {
            this.pushToACDL({
                event: 'cart-payment-error',
                error: {
                    message: message,
                },
            });
        },

        AddToCart: product => {
            this.pushToACDL({
                event: 'add-to-cart',
                ecommerce: {product: product},
            });
        },
    };

    constructor() {
        if (window.adobeDataLayer) {
            this.getOsanoConsent();
            this.setElements();
            this.eventListeners();
        }
    }

    setElements() {
        this.elements.acdlLinks = document.querySelectorAll(this.selectors.acdlLinks);
    }

    eventListeners() {
        this.elements.acdlLinks?.forEach(link => {
            link.addEventListener('click', this.handleElementClicked);
        });
    }

    handleElementClicked = e => {
        const isAjax = e.target.getAttribute('data-ajax');
        !isAjax && e.preventDefault();

        if (e.currentTarget.nodeName === 'A') {
            const hrefValue = e.currentTarget.getAttribute('href');
            const isRedirected = e.currentTarget.getAttribute('acdl-redirect'); //add (acdl-redirect="true") attr to the element if you want to enable its href value

            this.getAttributes(e);
            isRedirected === 'true' && (window.location.href = hrefValue);
        } else if (
            (e.currentTarget.nodeName === 'BUTTON' || e.currentTarget.nodeName === 'INPUT') &&
            e.currentTarget.type === 'submit'
        ) {
            const formElement = e.currentTarget.closest('form');
            const fieldsRequired = formElement?.querySelectorAll(
                'input[required], input[type="checkbox"][required], select[required]'
            );

            formElement?.reportValidity();
            fieldsRequired && this.handleFieldsValidation(fieldsRequired);
            if (!this.variables.isFieldsValid) {
                return;
            }

            this.getAttributes(e);
            !isAjax && formElement?.submit();
        }
    };

    handleFieldsValidation = fieldsRequired => {
        fieldsRequired.forEach(field => {
            this.variables.isFieldsValid = !(
                (field.tagName.toLowerCase() === 'select' && field.selectedIndex === 0) ||
                (field.tagName.toLowerCase() === 'input' &&
                    field.type.toLowerCase() === 'checkbox' &&
                    !field.checked) ||
                (field.tagName.toLowerCase() === 'input' && field.value.trim() === '')
            );
        });
    };

    getAttributes = e => {
        const attributes = e.currentTarget.attributes;
        const dataACDLAttributes = {};

        Array.from(attributes)
            .filter(attr => attr.name.startsWith('data-acdl-'))
            .forEach(attr => {
                const attrName = attr.name.split('--');

                if (attrName[0] === 'data-acdl-event') {
                    dataACDLAttributes.event = attr.value;
                } else {
                    let objectName = attrName[0].split('-')[2];
                    // html attributes always converted to lowercase - this is a workaround to meet the requirements
                    if (objectName === 'etoc') {
                        objectName = 'eTOC';
                    }
                    if (!dataACDLAttributes[objectName]) {
                        dataACDLAttributes[objectName] = {};
                    }
                    if (attrName.length > 2) {
                        const keys = attrName.slice(1);
                        const nestedKey = keys.pop();
                        const nestedObj = keys.reduce((obj, key) => {
                            if (!obj[key]) {
                                obj[key] = {};
                            }
                            return obj[key];
                        }, dataACDLAttributes[objectName]);
                        nestedObj[nestedKey] = attr.value;
                    } else {
                        const key = attrName[1];
                        dataACDLAttributes[objectName][key] = attr.value;
                    }
                }
            });

        this.pushToACDL(dataACDLAttributes);
    };

    ajaxPageLoad(data) {
        this.elements.updatedACDL = this.getUpdatedACDL(data); // return the new ACDL object coming from the search result ajax response
        window.adobeDataLayer.push({event: 'page-load', search: {...this.elements.updatedACDL?.search}});
    }

    // for advanced & citation search
    changeTabsLoad(target) {
        this.elements.pageObj = window.adobeDataLayer.getState().page;
        target.closest('.citation-search__tab') && (this.elements.pageObj['secondary-section'] = 'citation search');
        target.closest('.adv-search__tab') && (this.elements.pageObj['secondary-section'] = 'advanced');
        window.adobeDataLayer.push({event: 'page-load', page: {...this.elements.pageObj}});
    }
    getUpdatedACDL(htmlText) {
        try {
            // Extract the script tag from the response
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlText, 'text/html');
            const scriptTag = doc.getElementById('adobeDigitalData');

            // Extract the JavaScript code from the script tag
            const jsCode = scriptTag.innerHTML;

            // Use a regular expression to match the adobeDataLayer object
            const obj = jsCode.match(/window\.adobeDataLayer\.push\((\{.*\})\);/s)[1];

            // Extract the adobeDataLayer object and parse it as JSON
            const adobeDataLayer = JSON.parse(obj);

            return adobeDataLayer;
        } catch (error) {
            console.error(`Error occurred while parsing adobeDigitalData: ${error}`);
            return null;
        }
    }

    getOsanoConsent() {
        let isOsanoRendered = false,
            osanoConsent = null,
            adobeDataLayerObj = {};

        adobeDataLayerObj.event = 'page-load';
        adobeDataLayerObj.user = {};

        const intervalID = setInterval(() => {
            window.Osano &&
                window.Osano('onInitialized', consent => {
                    isOsanoRendered = true;
                    osanoConsent = consent;
                });

            if (isOsanoRendered) {
                clearInterval(intervalID);
                adobeDataLayerObj.user[
                    'consent-osano'
                ] = `analytics: ${osanoConsent?.ANALYTICS} | marketing: ${osanoConsent?.MARKETING} | personalization: ${osanoConsent?.PERSONALIZATION} | essential: ${osanoConsent?.ESSENTIAL}`;
                window.adobeDataLayer.push(adobeDataLayerObj);
            }
        }, 50);
    }

    pushToACDL(obj) {
        window.adobeDataLayer.push(obj);
    }
}
